import { ISignCommand } from '@/sign/commands/isign.command';

export class ReadKeyCommand implements ISignCommand {
  public async execute(prms?: any): Promise<any> {
    return Promise.resolve(prms);
  }
}
